import React from "react";
import { BrowserRouter, Switch, Redirect, Route } from "react-router-dom";

import BasePage from "./view/app";
import AuthPage from "./view/auth";
import { APP_NAME, IS_APP_PRODUCTION } from "./constants/app";
import { useAuth } from "./plugins/CookieAuthPlugin";
import PrivacyPolicy from "./static/PrivacyPolicy";
import TermsAndConditions from "./static/TermsAndConditions";
import DeleteUserRequest from "./static/DeleteUserRequest";
export default function Routes() {
	const { user } = useAuth();
	return (
		<BrowserRouter basename={IS_APP_PRODUCTION ? `/` : APP_NAME}>
			<Switch>
				<Route path="/privacy-policy" component={PrivacyPolicy} />
				<Route path="/terms-and-conditions" component={TermsAndConditions} />
				<Route path="/delete-user-request" component={DeleteUserRequest} />
				{user ? <Redirect from="/login" to="/" /> : <AuthPage />}

				{user ? <BasePage /> : <Redirect to="/login" />}
			</Switch>
		</BrowserRouter>
	);
}
